'use client';
import React, { useEffect, useLayoutEffect, useRef, useState} from 'react';
import { TextField } from '@mui/material';
import { SelectionData } from '../questions';
import ClientComponent from '@/components/builder/client_component';
import cssStyles  from "./questioniar_component.module.scss";

const TextAreaChoice: React.FC<SelectionData> = ({setSelectedAnswer, choices, editData, ...props}) => {


    const previousChoiceId = useRef<any>();

    if(editData && editData.responses && editData.responses.length > 0 && 
      editData.responses[0].answers && editData.responses[0].answers.length > 0){
        const answer = editData.responses[0].answers[0] as any;
        previousChoiceId.current = answer;
    }
  
    const getAnswerObject = (value: string) => {
      return {
        choiceID: 1,
        choice:  value
      }
    }
  
    useEffect(()=>{
      if( previousChoiceId.current){
        setSelectedAnswer([previousChoiceId.current])
      }
    },[previousChoiceId.current])
  
    const [textValue, setTextValue] = useState(previousChoiceId.current?.choice);
  
    const handleTextChange = (event:React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const enteredValue = event.target.value;
      setTextValue(enteredValue);
      setSelectedAnswer([getAnswerObject(enteredValue.replace(/[<>:*]/g, ''))])
    };
  
    return (
      <>
      <TextField
        placeholder="Enter Consideration"
        multiline
        rows={8}
        variant="outlined"
        value={textValue}
        onChange={handleTextChange}
        className={cssStyles["consideration-box"]}
      />
    
      </>
    )
  }
  export default ClientComponent(TextAreaChoice);